export const faqsAccordion = () => {
    
    const accordions = document.querySelectorAll('.js-toggle-accordion');

    // Add a click event listener to each of these elements
    accordions.forEach(function(accordion) {
        accordion.addEventListener('click', function() {
            // Get the next sibling element which is the '.faqs__answer'
            const answer = this.nextElementSibling;

            // Toggle the 'open' class for the clicked accordion
            this.classList.toggle('open');

            // Slide down if not visible, otherwise slide up
            if (answer.style.maxHeight) {
                // If the element is open, close it
                answer.style.maxHeight = null;
                answer.style.paddingTop = "0"; 
                answer.style.paddingBottom = "0"; 
                answer.style.overflow = "hidden";
            } else {
                // If the element is closed, open it
                answer.style.maxHeight = answer.scrollHeight + "px";
                answer.style.paddingTop = "20px"; 
                answer.style.paddingBottom = "20px"; 
                answer.style.overflow = "visible";
            }
        });
    });
};